import { Injector } from '@angular/core';
import { ModalBlocker } from './modal-blocker';

export function exposeModalBlocker(injector: Injector): void {
  const instance = injector.get(ModalBlocker);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).modalBlocker = {
    blockModals: instance.blockModals.bind(instance),
    unblockModals: instance.unblockModals.bind(instance),
    blockAllModals: instance.blockAllModals.bind(instance),
    getAllPersistedModals: instance.getAllPersistedModals.bind(instance),
    clearBlockedModals: instance.clearBlockedModals.bind(instance),
    closeAllModals: instance.closeAllModals.bind(instance),
  };
}
